import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {ConfigLoaderService} from '../../Shared/Services/Config/config-loader.service';
import { Router } from '@angular/router';
@Component({
    selector: 'app-maintainance-page',
    templateUrl: './maintainance-page.component.html',
    styleUrls: ['./maintainance-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MaintainancePageComponent implements OnInit {
  preloader: boolean = false;
  
  constructor(
    private router: Router,
  ) { }

  ngOnInit(): void {
    console.log('hereh')
   if (ConfigLoaderService.settings.AppSettings.ShowMaintainancePage.toUpperCase() != "TRUE") {
      this.preloader=true;
      this.router.navigate(["/"])
    }
  }

}
